<div class="toast-container">
  <div class="toast" *ngFor="let m of messages()" [class.success]="m.type==='success'" [class.error]="m.type==='error'" [class.info]="m.type==='info'">
    <span class="text">{{ m.text }}</span>
    <button type="button" class="close" (click)="dismiss(m.id)">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
</div>


